export const EMAIL_REGEX = new RegExp(
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
);

// Raw special characters for display/reference
export const PASSWORD_SPECIAL_CHARS = /[!@#$%^&*()\-_=+{}[\]|\\`":;'<>.,?~]/;

export const MIN_PASSWORD_LENGTH = 8;
